import React from 'react';
import { SupplierOverview } from './components/SupplierOverview';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <SupplierOverview data-id="element-1" />
    </div>;
}